module.exports = __webpack_public_path__ + "static/media/1POLICY38.702bfd4a.jpg";